<template>
  <g id="prototype-v2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="merchant_create-coupon" transform="translate(-264.000000, -90.000000)">
      <g id="arrow_back" transform="translate(260.000000, 86.000000)">
        <polygon id="Path" points="0 0 26 0 26 26 0 26"></polygon>
        <path
          d="M20.5833333,11.9166667 L8.4825,11.9166667
          L13.7691667,6.63 C14.1916667,6.2075 14.1916667,5.51416667
          13.7691667,5.09166667 C13.3466667,4.66916667 12.6641667,4.66916667
          12.2416667,5.09166667 L5.1025,12.2308333 C4.68,12.6533333
          4.68,13.3358333 5.1025,13.7583333 L12.2416667,20.8975
          C12.6641667,21.32 13.3466667,21.32 13.7691667,20.8975
          C14.1916667,20.475 14.1916667,19.7925 13.7691667,19.37
          L8.4825,14.0833333 L20.5833333,14.0833333 C21.1791667,14.0833333
          21.6666667,13.5958333 21.6666667,13 C21.6666667,12.4041667
          21.1791667,11.9166667 20.5833333,11.9166667 Z"
          id="Path"
          :fill="iconColor"
          fill-rule="nonzero"
        ></path>
      </g>
    </g>
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
